<div class="area-list-item">

    <div class="area-list-item__header" [title]="area.Nm">
        <div class="area-list-item__type-icon-container">
            <div class="area-list-item__type-icon" [ngClass]="{
            'area-list-item__type-icon--polygon' : (area.Tp === 1),
            'area-list-item__type-icon--circle' : (area.Tp === 2),
            'area-list-item__type-icon--line' : (area.Tp === 3)
        }">
                <span class="tag"></span>
            </div>
        </div>


        <div class="area-list-item__label">{{ area.Nm }}</div>
        <div class="area-list-item__edit-icon" (click)="editArea()"></div>
    </div>

</div>